import axios from 'axios'
import {errorHelper, messageHelper} from '../helper.js'
import {USER_URL, REFERENCES_URL, AUTH_URL, LOAD_EMAIL_LIST_URL, UNSUBSCRIBE_URL} from '../../../vars'

/**
 * @namespace PersonalData
 * @description Личный кабинет (Page: /personak-data)
 */
export default {
  state: {
    photo: ''
  },
  mutations: {
    UPDATE_PHOTO(state, data) {
      state.photo = data
    }
  },
  actions: {
    async UNSUBSCRIBE(ctx, data) {
      try {
        const res = await axios.post(UNSUBSCRIBE_URL, data);
        return res.data;
      } catch (e) {
        console.log(e);
        // messageHelper(e.detail, 'error', 6000, )
        throw e;
      }
    },


    /**
     *
     * @param {Object} ctx
     * @param {Object} data Данные для обновления личной информации
     * @returns {object} Резуьтат обновления данных
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof PersonalData
     */
    async UPDATE_INDIVIDUAL(ctx, data) {
      try {
        const res = await axios.patch(`${USER_URL}individual/detail/`, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`
          }
        })
        console.log(res)
        return res
      } catch (e) {
        errorHelper(e)
        messageHelper('', 'error', 6000, e)
        throw e
      }
    },
    /**
     * Отправляет фото записывает данные
     * @param {Object} ctx
     * @param {Object} data Данные для загрзуки фото
     * @returns {Object} Объект с данными ответа записи фото
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Personal data
     */
    async LOAD_PHOTO(ctx, data) {

      try {
        const res = await axios.post(`${USER_URL}individual/detail/`, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`
          }
        })
        await ctx.commit('UPDATE_PHOTO', res.data[0])
        return res
      } catch (e) {

        errorHelper(e)
        messageHelper(e.response.data.message, 'error', 6000, e)
        throw e
      }
    },

    async LOAD_EMAIL_LIST(ctx, data) {
      try {
        const res = await axios.post(LOAD_EMAIL_LIST_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`
          }
        })
        return res.data
      } catch (e) {

        errorHelper(e)
        messageHelper(e.response.data.message, 'error', 6000, e)
        throw e
      }
    },


    /**
     * Возвращает резуьтат запроса
     * @param {Object} ctx
     * @param {String} data Язык данных
     * @returns {object} Данные на другом языке
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof PersonalData
     */
    async GET_ACADEMIC_DEGREE(ctx, data) {

      const headers = {
        headers: {
          Authorization: `Token ${localStorage.token}`,
        }
      };

      try {
        const res = await axios.get(`${REFERENCES_URL}academic-degree/list/?lang=${data}`, headers)

        return res
      } catch (e) {
        errorHelper(e)
        messageHelper('', 'error', 6000, e)
        throw e
      }
    },
    /**
     * Возвращает резуьтат запроса
     * @param {Object} ctx
     * @param {String} data Язык данных
     * @returns {object} Данные на другом языке
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof PersonalData
     */
    async GET_ACADEMIC_DEGREE_REG(ctx, data) {

      try {
        const res = await axios.get(`${REFERENCES_URL}academic-degree/list/?lang=${data}`)

        return res
      } catch (e) {
        errorHelper(e)
        messageHelper('', 'error', 6000, e)
        throw e
      }
    },
    /**
     * Возвращает резуьтат запроса
     * @param {Object} ctx
     * @param {String} data Язык данных
     * @returns {object} Данные на другом языке
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof PersonalData
     */
    async GET_ACADEMIC_RANK(ctx, data) {

      const headers = {
        headers: {
          Authorization: `Token ${localStorage.token}`,
        }
      };

      try {
        const res = await axios.get(`${REFERENCES_URL}academic-rank/list/?lang=${data}`, headers)

        return res
      } catch (e) {
        errorHelper(e)
        messageHelper('', 'error', 6000, e)
        throw e
      }
    },
    /**
     * Возвращает резуьтат запроса
     * @param {Object} ctx
     * @param {String} data Язык данных
     * @returns {object} Данные на другом языке
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof PersonalData
     */
    async GET_ACADEMIC_RANK_REG(ctx, data) {

      try {
        const res = await axios.get(`${REFERENCES_URL}academic-rank/list/?lang=${data}`)

        return res
      } catch (e) {
        errorHelper(e)
        messageHelper('', 'error', 6000, e)
        throw e
      }
    },
    /**
     *
     * @param {Object} ctx
     * @returns {Object} Данные профиль пользователя
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof PersonalData
     */
    async GET_PERSONAL_DATA(ctx) {
      try {
        const {data} = await axios.get(`${AUTH_URL}profile/`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          }
        })

        return data
      } catch (e) {
        errorHelper(e)
        messageHelper('', 'error', 6000, e)
        throw e
      }
    }
  },
  getters: {
    GETTERS_PHOTO_USER(state) {
      return state.photo
    }
  }
}
